// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HJ-z","modalContent":"IJ-z","header":"JJ-z","close":"KJ-z"};